import { formatCurrency } from '../../../../utils/formatNumber';
import { Link, Typography } from '@mui/material';

const cellConfig = {
    Amount: {
        calculator: (data, columnId) => {
            return data.reduce((acc, row) => {
                const value = row[columnId] || 0;
                return acc + value;
            }, 0);
        },
        formatter: (value) => formatCurrency(value)
    },
    CommissionsTotal: {
        calculator: (data, columnId) => {
            return data.reduce((acc, row) => {
                let items = [];
                try {
                    items = JSON.parse(row[columnId] || '[]');
                } catch (e) {
                    console.error('Error parsing JSON:', e);
                }
                if (!Array.isArray(items)) {
                    items = [];
                }
                return acc + items.reduce((sum, item) => sum + item.value, 0);
            }, 0);
        },
        formatter: (value, handleClick) =>
            value ? (
                <Link underline="hover" onClick={handleClick}>{formatCurrency(value)}</Link>
            ) : (
                <Typography>{formatCurrency(value)}</Typography>
            )
    }
};
export default cellConfig;
